var _script, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoggedIn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "-1 -1 30 30"
}, props), _script || (_script = /*#__PURE__*/React.createElement("script", {
  type: "text/javascript"
}, "(function updateColors() {\n    const parent = document.currentScript.parentElement;\n    const circle = document.currentScript.parentElement.querySelector('circle');\n    const parentFillColor = window.getComputedStyle(parent).fill;\n    const parentBorderColor = window.getComputedStyle(parent).borderColor;\n    circle.setAttribute('stroke', parentBorderColor);\n}())")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13.94,
  cy: 13.94,
  r: 13.94
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M19.775 20.973v-1.55a3.1 3.1 0 0 0-3.1-3.099h-4.649a3.1 3.1 0 0 0-3.1 3.1v1.55M14.35 13.226a3.1 3.1 0 1 0 0-6.199 3.1 3.1 0 0 0 0 6.2"
})));
export default SvgLoggedIn;